import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import i18n from '../i18n.js'
// import en from 'vuetify/src/locale/en.ts'
// import ar from 'vuetify/src/locale/ar.ts'

Vue.use(Vuetify, {
  iconfont: 'mdi' || 'md' || 'fa',
  rtl: true,
  // lang: {
  // locales: { en },
  // current: 'en'
  // }
  lang: {
    t: (key, ...params) => (i18n.t(key, params) ? i18n.t(key, params) : key)
  }
})
